import React, { useCallback } from 'react';
import { useIntl } from 'react-intl-next';
import { elementInsertSidePanel } from '@atlaskit/editor-common/messages';
import { typeAheadListMessages } from '@atlaskit/editor-common/type-ahead';
import { SideInsertPanel } from '@atlaskit/editor-element-browser';
import AddIcon from '@atlaskit/icon/core/add';
import { Pressable, xcss } from '@atlaskit/primitives';
var viewAllButtonStyles = xcss({
  background: "var(--ds-background-input-pressed, #FFFFFF)",
  position: 'sticky',
  bottom: '-4px',
  width: '100%',
  height: '40px',
  color: 'color.text.subtle',
  fontWeight: "var(--ds-font-weight-medium, 500)",
  ':hover': {
    textDecoration: 'underline'
  },
  ':active': {
    color: 'color.text'
  }
});
var INSERT_PANEL_WIDTH = 320;
export var ViewAllButton = function ViewAllButton(_ref) {
  var items = _ref.items,
    editorApi = _ref.editorApi,
    onItemInsert = _ref.onItemInsert,
    onPanelOpen = _ref.onPanelOpen;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var handleClick = useCallback(function () {
    var _editorApi$contextPan;
    var showContextPanel = editorApi === null || editorApi === void 0 || (_editorApi$contextPan = editorApi.contextPanel) === null || _editorApi$contextPan === void 0 || (_editorApi$contextPan = _editorApi$contextPan.actions) === null || _editorApi$contextPan === void 0 ? void 0 : _editorApi$contextPan.showPanel;
    if (!showContextPanel || !items) {
      return;
    }

    // Opens main editor controls side panel
    showContextPanel({
      id: 'editor-element-insert-sidebar-panel',
      headerComponentElements: {
        headerLabel: elementInsertSidePanel.title,
        HeaderIcon: function HeaderIcon() {
          return /*#__PURE__*/React.createElement(AddIcon, {
            label: formatMessage(elementInsertSidePanel.title)
          });
        }
      },
      BodyComponent: function BodyComponent() {
        return /*#__PURE__*/React.createElement(SideInsertPanel, {
          items: items,
          onItemInsert: onItemInsert
        });
      }
    }, 'push', INSERT_PANEL_WIDTH);

    // Closes typeahead
    if (onPanelOpen) {
      onPanelOpen();
    }
  }, [editorApi, formatMessage, items, onItemInsert, onPanelOpen]);
  return /*#__PURE__*/React.createElement(Pressable, {
    xcss: viewAllButtonStyles,
    onClick: handleClick
  }, formatMessage(typeAheadListMessages.viewAllInserts));
};